import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '@lib/components/Table/Table';
import { OrderingState, PaginationState } from '@lib/enums/urls';
import { AiUsageByUserItem } from '../utils/types';
import getAiUsageTableColumns from '../utils/getAiUsageTableColumns';
import toAiUsageRows from '../utils/toAiUsageRows';

export interface AiUsageTopUsersTableProps {
  collection: AiUsageByUserItem[];
  loading: boolean;
  orderingState: OrderingState;
  paginationState: PaginationState;
}

function AiUsageTopUsersTable({
  collection,
  loading,
  orderingState,
  paginationState,
}: AiUsageTopUsersTableProps) {
  const { t, i18n } = useTranslation();

  const topUsers = useMemo(() => toAiUsageRows(collection), [collection]);
  const columns = useMemo(
    () => getAiUsageTableColumns({ language: i18n.language, t }),
    [i18n.language, t],
  );

  return (
    <Table
      columns={columns}
      data={topUsers}
      loading={loading}
      orderingState={orderingState}
      paginationState={paginationState}
      // The summary is capped at five rows, so measuring against the
      // rendered count keeps its pagination controls off.
      totalEntries={topUsers.length}
    />
  );
}

export default memo(AiUsageTopUsersTable);
